module.exports = __webpack_public_path__ + "img/tucson.498d41ff.png";